<template>
  <div class="intention-box-main cvs-intention" :class="[isDarkTheme? 'dark-theme-cvs-intention-modal':'']" v-if="show" @click="clone">
    <!-- <transition name="opacity">
      <div class="cover" v-if="show" @click="clone"></div>
    </transition> -->
    <transition name="alert">
       <!-- :style="{height: '468px'}" -->
      <div class="box" @click.stop>
        <div class="name">提升求职效率</div>
         <div class="message">更新求职状态、意向岗位，为你精准匹配简历模板、高薪职位，求职效率翻倍</div>

        <!-- 设置求职意向 弹窗 -->
        <div v-if="!dialogVisible">
          <template v-if="isDarkTheme">
            <div class="title">求职状态</div>
            <div class="work-status">
              <div v-if="userIdentify === 'already_work'" class="work-status-left">职场人{{userIntentions.expect_status ? `-${userIntentions.expect_status}` : ''}}</div>
              <div v-else class="work-status-left">学生党{{userIntentions.expect_work_type.length ? `-${userIntentions.expect_work_type.join(',')}` : ''}}</div>

              <div class="work-status-right" @click="showDialogWorkStatus()">
                <span class="iconfont iconFrame1"></span>编辑状态
              </div>
            </div>
          </template>
          <div class="flex-c work-type" v-else>
            <div class="title">求职状态</div>
            <!-- <div class="type flex1">
              <div
                :class="['type-item', item === work_time ? 'active' : '']"
                v-for="(item, index) in work_time_all"
                :key="index"
                @click="work_time = item">
                {{item}}
              </div>
            </div> -->
            <div class="work-status flex1">
              <div v-if="userIdentify === 'already_work'" class="work-status-left">职场人{{userIntentions.expect_status ? `-${userIntentions.expect_status}` : ''}}</div>
              <div v-else class="work-status-left">学生党{{userIntentions.expect_work_type.length ? `-${userIntentions.expect_work_type.join(',')}` : ''}}</div>

              <div class="work-status-right" @click="showDialogWorkStatus()">编辑状态</div>
            </div>
          </div>

          <div class="title">职位类型</div>
          <select-box>
            <template v-slot:input>
              <div class="industries-input">
                <div class="item" v-for="(item, index) in professionsConfirmData" :key="index">
                  <div class="item-text">{{item.title}}</div>
                  <div class="item-clone iconfont" :class="[isDarkTheme ? 'iconx' : 'iconcha']" @click.stop="handleCheckProfessions(item)"></div>
                </div>
                <div class="item" v-if="!professionsConfirmData.length">不限</div>
              </div>
            </template>
            <template v-slot:content>
              <div class="professionsTree">
                <div class="tagContent">
                  <div class="level1 reset-scrollbar">
                    <div class="item" :class="[professionsOptions.level1Index === index?'active':'']" v-for="(item,index) in professionsTree" :key="index" @click="professionsOptions.level1Index = index">
                      <span>{{item.label}}</span>
                      <span class="iconfont iconjinru" v-if="isDarkTheme"></span>
                    </div>
                  </div>
                  <template v-for="(item,index) in professionsTree">
                    <div class="levels reset-scrollbar" v-if="professionsOptions.level1Index === index" :key="index">
                      <div class="list">
                        <div class="item" :class="[item.checked?'active':'']" @click="handleCheckProfessions({level1Index: index, listItem:item, type:'level1'})">
                          <span>{{item.title}}</span>
                        </div>
                      </div>

                      <template v-for="(sitem, sindex) in item.list">
                        <div :key="sindex">
                          <div class="level2"><span>{{sitem.title}}</span></div>
                          <div class="list">
                            <!-- level2 -->
                              <!-- :class="[sitem.checked?'active':'',item.checked?'disabled':'']" -->
                            <div class="item"
                              :class="[sitem.checked?'active':'']"
                              @click="handleCheckProfessions({level1Index: index, level2Index: sindex, listItem:sitem, type:'level2'})"
                            >
                              <span>{{sitem.title}}</span>
                            </div>
                            <!-- level3 -->
                            <!-- :class="[ssitem.checked ?'active':'',item.checked || sitem.checked?'disabled':'']" -->
                            <div class="item"
                              :class="[ssitem.checked ?'active':'']"
                              v-for="(ssitem, ssindex) in sitem.list" :key="ssindex"
                              @click="handleCheckProfessions({level1Index: index, level2Index: sindex, level3Index: ssindex, listItem:ssitem, type:'level3'})"
                            >
                              <span>{{ssitem.title}}</span>
                            </div>

                          </div>
                        </div>
                      </template>
                      <div class="tips">
                        <p>如果没找到您的意向职类，请点击这里</p>
                        <span class="colf6" @click="feedVisibile = !feedVisibile">立即反馈</span>
                      </div>
                    </div>
                  </template>
                </div>
              </div>

            </template>
          </select-box>

          <div class="title">行业领域</div>
          <select-box>
            <template v-slot:input>
              <div class="industries-input">
                <div
                  class="item"
                  v-for="(item, index) in selectIndustriesArr"
                  :key="index">
                  {{item.name}}
                  <div class="item-clone iconfont" :class="[isDarkTheme ? 'iconx' : 'iconcha']" @click.stop="selectIndustries(item)" v-if="item.id !== 0"></div>
                </div>
              </div>
            </template>
            <template v-slot:content>
              <div class="industries">
                <div
                  :class="['item', industry_names && industry_names.indexOf(item.name) !== -1 ? 'active' : '']"
                  v-for="(item, index) in allIndustriesArr"
                  :key="index"
                  @click="selectIndustries(item)">
                    <span>{{item.name}}</span>
                  </div>
              </div>
            </template>
          </select-box>

          <div class="title">工作地点</div>
          <select-box>
            <template v-slot:input>
              <div class="industries-input">
                <div class="item" v-for="(item, index) in citiesArr" :key="index">
                  {{item.city_name}}
                  <div class="item-clone iconfont" :class="[isDarkTheme ? 'iconx' : 'iconcha']" @click.stop="selectCitie(item)" v-if="item.city_name !== '全国'"></div>
                </div>
                <div class="item" v-if="!citiesArr.length">全国</div>
              </div>
            </template>
            <template v-slot:content>
              <div class="city">
                <div class="left-model reset-scrollbar">
                  <div
                    :class="['item', citiesIndex === index ? 'active' : '']"
                    v-for="(item, index) in cityList"
                    :key="index"
                    @click="citiesIndex = index"
                    v-show="item.group_name !== '其他'"
                  >
                    <span>{{item.group_name}}</span>
                    <span class="iconfont iconjinru" v-if="isDarkTheme"></span>
                  </div>
                </div>
                <div class="right-model reset-scrollbar" v-if="cityList[citiesIndex]">
                  <div
                    :class="['menu', (cities && cities.indexOf(item.city_id) !== -1 || !citiesArr.length && item.city_id===0) ? 'active' : '']"
                    v-for="(item, index) in cityList[citiesIndex].part_cities"
                    :key="item.id"
                    @click="selectCitie(item)"
                  >
                    <span>{{item.city_name}}</span>
                  </div>
                </div>
              </div>
            </template>
          </select-box>

          <div v-if="userIdentify === 'already_work'">
            <div class="title">期望薪资</div>
            <div class="salary">
              <label class="salary-item">
                <el-select v-model="expect_min_salary" :popper-class="[isDarkTheme? 'dark-theme-select-intention-select':'']"  placeholder="请选择" @change="min => (minChange(min),isActive())">
                  <el-option
                    v-for="item in 100"
                    :key="item"
                    :label="item === 100 ? '100k以上' : item"
                    :value="item">
                  </el-option>
                </el-select>
                <div class="salary-item-text">K/月</div>
              </label>
              <div class="salary-text" v-if="expect_min_salary < 100">至</div>
              <label class="salary-item" v-if="expect_min_salary < 100">
                <el-select v-model="expect_max_salary" :popper-class="[isDarkTheme? 'dark-theme-select-intention-select':'']"  placeholder="请选择" @change="isActive">
                  <el-option
                    v-for="item in 100"
                    v-if="item > expect_min_salary && item <= expect_min_salary * 2"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
                <div class="salary-item-text">K/月</div>
              </label>
            </div>
            <!-- <div class="title">当前状态</div>
            <div class="type">
              <div
                :class="['type-item', item === expect_status ? 'active' : '']"
                v-for="(item, index) in statusAll"
                :key="index"
                @click="expect_status = item;isActive();">
                {{item}}
              </div>
            </div> -->
          </div>

          <div class="btn">
            <button class="cancel" @click="clone" v-show="!isClose"><span>取消</span></button>
            <button :class="[isActiveSave || is_student ? 'active' : 'active']" @click="save"><span>保存</span></button>
          </div>
        </div>

        <!-- 编辑求职状态 弹窗 -->
        <div class="editor-work-status-dialog" v-else>
          <!-- 身份选择 -->
          <div class="editor-identify">
            <div class="editor-title">身份选择</div>
            <div class="select-info">
              <div class="editor-identify-btn" :class="{'active': identifyForm.nowIdentify === 'student'}" @click="handleEditorIdentify('student')">
                <span>学生党</span>
              </div>
              <div class="editor-identify-btn" :class="{'active': identifyForm.nowIdentify === 'already_work'}" @click="handleEditorIdentify('already_work')">
                <span>职场人</span>
              </div>
            </div>
          </div>

          <template v-if="identifyForm.nowIdentify === 'student'">
            <!-- 工作类型 -->
            <div class="editor-work-type">
              <div class="editor-title">工作类型</div>
              <el-checkbox-group v-model="identifyForm.expectWorkType">
                <el-checkbox v-for="item in identifyForm.expectWorkTypeList" :label="item" :key="item"></el-checkbox>
              </el-checkbox-group>
            </div>
          </template>

          <template v-if="identifyForm.nowIdentify === 'student' && identifyForm.expectWorkType.includes('实习')">
            <!-- 每周实习天数 -->
            <div class="title">每周实习天数</div>
            <el-select class="editor-days" :popper-class="[isDarkTheme? 'dark-theme-select-intention-select':'']"  v-model="identifyForm.internFrequency" placeholder="请选择">
              <el-option
                v-for="item in 7"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </template>

          <template v-if="identifyForm.nowIdentify === 'student' && identifyForm.expectWorkType.includes('实习')">
            <!-- 实习月份 -->
            <div class="title">实习月份</div>
            <div class="editor-time">
              <el-date-picker
                  v-model="identifyForm.onboardAt"
                  type="month"
                  placeholder="开始时间"
                  value-format="yyyy-MM-d"
                  :clearable="false"
                  :picker-options="pickerOptions"
                  @change="selectInternshipStartTime"/>
              <span>至</span>
              <el-date-picker
                  v-model="identifyForm.endAt"
                  type="month"
                  placeholder="结束时间"
                  value-format="yyyy-MM-d"
                  :clearable="false"
                  :picker-options="pickerOptions"
                  @change="selectInternshipEndTime"/>
            </div>
          </template>

          <template v-if="identifyForm.nowIdentify === 'already_work'">
            <!-- 当前工作状态 -->
            <div class="title">当前工作状态</div>
            <el-select class="editor-work-status" :popper-class="[isDarkTheme? 'dark-theme-select-intention-select':'']" v-model="identifyForm.expectStatus" placeholder="请选择">
              <el-option
                v-for="item in identifyForm.expectStatusList"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </template>

          <div class="btn">
            <button class="cancel" @click="goBack()"><span>上一步</span></button>
            <button :disabled="!jobStatusConfirmVisible" :class="{'disabled': !jobStatusConfirmVisible}" class="active" @click="saveIdentify()"><span>确定</span></button>
          </div>

        </div>

      </div>
    </transition>
    <feedback v-if="feedVisibile" @closeFeed="feedVisibile = false" />
  </div>
</template>
<script>
import moment from 'moment';
import selectBox from './select';
import {mapState} from 'vuex';
import api from '@/api';
import {dealSignatrue, get_tUser} from '@/assets/js/util';
import feedback from './feedback.vue'

export default {
  name: 'intentionBox',
  components: {
    selectBox,
    feedback
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    // userIntentions: {
    //   type: Object,
    //   required: false
    // },
    isClose: false,
    isDarkTheme: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      feedVisibile:false,
      moment,
      work_time_all: ['不限', '全职', '兼职', '实习'],
      work_time: '不限',
      industries: [],
      industry_names: [],
      allIndustriesArr: [],
      selectIndustriesArr: [],
      allProfessionsArr:[],
      professionNames: [],
      selectProfessionsArr: [],
      citiesIndex: 0,
      cities: [],
      cityList: [],
      citiesArr: [],
      expect_max_salary: '',
      expect_min_salary: '',
      expect_status: '',
      userIntention: {},
      statusAll: ['离职-随时到岗', '在职-考虑机会', '在职-暂不考虑'],
      isActiveSave: false,
      is_student: false,
      professions: [],//职位类型列表
      professionsConfirmData: [],//已选择职位集合
      professionsOptions:{
        level1Index:0,
      },
      professionsTree:[], //职位类型数据集合
      _c_t: null,


      userIdentify: null, // 用户求职身份
      userIntentions: {
        expect_status: '',
        expect_work_type: [],
      }, // 用户求职意向信息


      dialogVisible: false, // 求职状态弹窗
      identifyForm: { // 编辑求职状态
        nowIdentify: null, //身份 - 学生党 或 求职者
        expectWorkType: [], // 学生党-工作类型
        expectWorkTypeList: [
          '实习',
          '校招',
          '社招'
        ],
        internFrequency: 5, // 学生党-每周实习天数 默认值：5
        onboardAt: moment().format('YYYY-MM-01'), // 学生党-实习开始时间
        endAt: moment().add(3, 'M').format('YYYY-MM-01'), // 学生党-实习结束时间
        expectStatus: null, // 求职者-当前工作状态
        expectStatusList: [ // 求职者-当前工作状态选择列表
           '离职，随时到岗',
           '在职，看看机会',
           '在职，暂不考虑'
        ]
      },
      pickerOptions: { // 日期选择器的控制参数，
        disabledDate: this.handleDisabledDate // disabledDate：日期是否可选
      }
    };
  },
  computed: {
    // ...mapState('jobs', ['intention'
    //   // ,
    //   // 'userIntentions'
    // ])
    jobStatusConfirmVisible () {
      let flag1 = this.identifyForm.nowIdentify === 'student' && this.identifyForm.expectWorkType.length && new Date(this.identifyForm.endAt).getTime() >= new Date(this.identifyForm.onboardAt).getTime()
      let flag2 = this.identifyForm.nowIdentify === 'already_work' && this.identifyForm.expectStatus
      return flag1 || flag2
    }
  },
  watch: {
    // 数据变化更新弹窗文案
    userIntention: {
      keep: true,
      immediate: true,
      handler: async function (userIntention) {
        // userIntention = userIntentions
        if (typeof userIntention.work_time === 'string') {
          if (userIntention.work_time === '不限' || userIntention.work_time === '未开启')
            this.work_time = '不限';
          else
            this.work_time = userIntention.work_time;
        } else {
          if (!userIntention.work_time || !userIntention.work_time.length){
            this.work_time = "不限"
          }else{
            this.work_time = userIntention.work_time && userIntention.work_time[0]
          }
        }
        if (!userIntention.city_ids || !userIntention.city_ids.length) {
            this.cities = [];
        } else {
          this.cities = userIntention.city_ids || [];
          this.getSelectedCities()
        }
        // if (!userIntention.profession_ids || !userIntention.profession_ids.length) {
        //   this.professions = [];
        // } else {
        //   this.professions = userIntention.profession_ids && userIntention.profession_ids.length ? userIntention.profession_ids : [];
        //   try {
        //     // 重新获取选中的职位，解决显示选中的选项不一致的问题
        //     // await this.getAllProfessions()
        //     // this.getSelectedProfessions()
        //   } catch (e) {
        //     console.error(e);
        //   }
        // }
        if (!userIntention.industry_ids || !userIntention.industry_ids.length) {
          this.industries = [];
        } else {
          this.industries = userIntention.industry_ids && userIntention.industry_ids.length ? userIntention.industry_ids : [];
          this.getSelectedIndustries()
        }
        this.$forceUpdate();
      }
    },
    show:{
      async handler(newVal) {
        let html = document.querySelector('html')
        html.style.height = '100%'
        // 弹窗显示重新请求数据，解决修改之后点击取消关闭弹窗再打开求职意向数据不统一问题
        if (newVal) {
          console.log("display")
          try {
            let userIntentions = await api.recruit.jobIntention({"platform": 'pc'});
            if (userIntentions.code === 1000) {
              //过滤为0的id
              userIntentions.data.city_ids = userIntentions.data.city_ids.filter(item=> item>0)

              this.userIntention = userIntentions.data;
              //获取职位类型
              this.getProfessionsTree(userIntentions.data.profession_ids)
            } else {
              this.$message.error(userIntentions.message)
            }
          } catch (e) {
            console.error(e)
          }
          html.style.overflow = 'hidden'
        }else {
          html.style.overflow = 'auto'

        }
      }
    }
  },
  async created() {
    this._c_t = get_tUser().c_t || ''
    this.getAllCity();
    // this.getAllProfessions();
    this.getAllIndustry();
    this.getData();
    this.$forceUpdate();
  },
  methods: {
    // 选择实习开始时间
    selectInternshipStartTime (startTime) {
      console.log(startTime)
      if (new Date(startTime).getTime() > new Date(this.identifyForm.endAt).getTime()) {
			  this.$message.error('开始时间不能晚于结束时间')
      }
    },
    // 选择实习结束时间
    selectInternshipEndTime (endTime) {
      console.log(endTime)
      if (new Date(endTime).getTime() < new Date(this.identifyForm.onboardAt).getTime()) {
			  this.$message.error('结束时间不能早于开始时间')
      }
    },
    // 期望实习月份只能选择现在或之后的时间
    handleDisabledDate (time) {
      // time：日期选择器里所有可选的时间
      if (new Date(time).getTime() < new Date().getTime()) {
        // 不可选
        return true
      } else {
        // 可选
        return false
      }
    },
    goBack () {
      this.dialogVisible = false
      // this.resetIdentifyForm()
    },
    resetIdentifyForm () {
      this.identifyForm = {
        nowIdentify: null,
        expectWorkType: [],
        expectWorkTypeList: [
          '实习',
          '校招',
          '社招'
        ],
        internFrequency: 5,
        onboardAt: this.moment().format('YYYY-MM-01'),
        endAt: this.moment().add(3, 'M').format('YYYY-MM-01'),
        expectStatus: null,
        expectStatusList: [
           '离职，随时到岗',
           '在职，看看机会',
           '在职，暂不考虑'
        ]
      }
    },
    // 保存身份信息
    saveIdentify () {
      let nowIdentify = this.identifyForm.nowIdentify
      if (!nowIdentify) return this.$message.success('请选择你的身份')
      let params = null
      if (nowIdentify === 'student') {
        params = {
          expect_work_type: this.identifyForm.expectWorkType,
          intern_frequency: this.identifyForm.internFrequency,
          onboard_at: this.identifyForm.onboardAt,
          end_at: this.identifyForm.endAt
        }
      } else if (nowIdentify === 'already_work') {
        params = {
          expect_status: this.identifyForm.expectStatus
        }
      }

      Promise.all([
        api.cvsV2.setIdentifyInfo(this._c_t, {status: nowIdentify}),
        api.recruit.setJobIntention(params)
      ]).then(resp => {
        this.$message.success('设置成功')
        this.getData()
        this.goBack()
      }).catch(e => {
        console.log(e)
      })

    },
    // 选择身份
    handleEditorIdentify (val) {
      // this.resetIdentifyForm()
      this.identifyForm.nowIdentify = val
    },
    // 到编辑求职状态弹窗
    showDialogWorkStatus () {
      this.dialogVisible = true
      this.identifyForm.nowIdentify = this.userIdentify
      this.identifyForm.expectStatus = this.userIntentions.expect_status

      if (this.userIntentions.onboard_at) {
        this.identifyForm.onboardAt = this.userIntentions.onboard_at
      }

      if (this.userIntentions.end_at) {
      this.identifyForm.endAt = this.userIntentions.end_at
      }

      if (this.userIntentions.intern_frequency) {
        this.identifyForm.internFrequency = this.userIntentions.intern_frequency
      }

      // 如果工作类型为空，默认全选（实习和校招）
      if (!this.userIntentions.expect_work_type.length) {
         this.identifyForm.expectWorkType = ["实习", "校招","社招"]
      } else {
        this.identifyForm.expectWorkType = this.userIntentions.expect_work_type
      }

    },
    getData () {
        Promise.all([
          api.cvsV2.getIdentifyInfo(this._c_t),
          api.recruit.jobIntention()
        ]).then(resp => {
           this.userIdentify = resp[0].data.status
           this.userIntentions = resp[1].data
           this.expect_max_salary = resp[1].data.expect_max_salary
           this.expect_min_salary = resp[1].data.expect_min_salary
        }).catch(e => {
          console.log(e)
        })

    },


    getSelectedIndustries() {
      this.industry_names = this.userIntention.industries
      // 处理期望行业选中
      if (this.industries.length > 0 && this.industries.indexOf(0) === -1) {
        this.selectIndustriesArr = []
        this.allIndustriesArr.map(item => {
          if (this.industry_names && this.industry_names.includes(item.name)) {
            item.check = 'active';
            this.selectIndustriesArr.push(item);
          }
        })
      } else {
        this.industry_names = ['不限']
        this.allIndustriesArr[0].check = 'active';
        this.selectIndustriesArr = [{ name: '不限', id: 0, check: 'active' }];
      }
    },
    async getAllIndustry() {
      await api.recruit.get_industries_list().then(res => {
        if (res.code === 1000) {
          //总数据
          let industriesArr = [{name: '不限', id: 0, check: ''}];
          let industry_ids = []
          res.data.forEach(item => {
            industry_ids.push(item.id)
            industriesArr.push({
              name: item.cn,
              id: item.id,
              check: '',
            });
          });
          this.allIndustriesArr = industriesArr
          this.getSelectedIndustries()
        }
      });
    },
    getSelectedCities () {
      let cityArrObject = {};
      if (this.cities && this.cities.length != 0 && this.cities.indexOf(0) === -1) {
        this.citiesArr = [];
        this.cityList.forEach(item => {
          item.part_cities.forEach(sitem => {
            if (this.cities && this.cities.includes(sitem.id)) {
              sitem.check = true;
              cityArrObject[sitem.id] = sitem;
            }
          });
        });
      }else{
        // cityArrObject = [{
        //   check: true,
        //   id: 0,
        //   city_id: 0,
        //   city_name: '全国'
        // }];
        cityArrObject = []
        this.cities = []
        this.cityList[0].part_cities[0].check = true

      }
      for (let key in cityArrObject) {
        this.citiesArr.push(cityArrObject[key]);
      }
    },
    async getAllCity () {
      let res1 = await api.recruit.toObtainCityNew({nums:0,job_count:0});
      let city = []
      Object.keys(res1.data).forEach((key,index)=>{
        let obj ={}
        obj.group_name = key=='hot_cities'?'热门城市':key;
        obj.part_cities = res1.data[key].map(item=>{
          item.id= item.city_id
          return item
        })
        city.push(obj)
      })
      let all_cities = city || [];
      let hot_cities = res1.data.hot_cities || [];
      hot_cities.unshift({city_name: '全国', id: 0, city_id: 0});
      all_cities[0] = {group_name: '热门城市', part_cities: hot_cities};
      this.cityList = all_cities;
      this.getSelectedCities()
    },
    minChange(min) {
      if (min < 100) {
        this.expect_max_salary = min + 1;
      }
      else {
        this.expect_max_salary = '';
      }
    },
    isActive() {
      this.isActiveSave = false;
      let reg = /(^\d{1,8}$)|(^\d{1,8}.\d{1,2}$)/;
      if (!this.expect_min_salary) {
        return '请选择最低薪资';
      }
      if (this.expect_min_salary < 100 && !this.expect_max_salary) {
        return '请选择最高薪资';
      }
      // if (this.expect_max_salary < this.expect_min_salary) {
      //   return '最低薪资不应大于最高薪资';
      // }
      if (!this.expect_status) {
        return '请选择当前状态';
      }
      this.isActiveSave = true;
      return true;
    },
    clone() {
      if (this.isClose) {
        return false;
      }
      this.$emit('clone');
    },
    selectCitie(data) {
      if (data.id === 0){
        this.cities = []
        this.citiesArr = []
        return false
      }

      if (this.cities.indexOf(data.id) === -1) {
        if(this.cities.indexOf(0) !== -1){
          this.cities = []
          this.citiesArr = []
        }
        if (this.citiesArr.length >= 3) {
          this.$message.warning('最多选择三个');
          return false;
        }
        this.cities.push(data.id);
        this.citiesArr.push(data);
      } else {
        this.cities.splice(this.cities.indexOf(data.id), 1);
        this.citiesArr.splice(this.citiesArr.indexOf(data), 1);
        if (!this.cities.length){
          this.cities = []
          this.citiesArr = []
          // this.citiesArr = [{
          //   check: true,
          //   id: 0,
          //   city_id: 0,
          //   city_name: '全国'
          // }]
        }
      }
    },
    selectIndustries(data) {
      // 点击的为不限
      if (data.id === 0) {
        this.industries = [];
        this.industry_names = ['不限']
        this.selectIndustriesArr = [{ name: '不限', id: 0, check: 'active' }]
        return false;
      }
      // 点击的不限之外的选项
      if (this.industry_names.indexOf(data.name) === -1) {
        // 初始化不限在列表中，点击别的选项之后要清空状态
        if (this.industry_names.indexOf('不限') !== -1){
          this.industries = []
          this.industry_names = []
          this.selectIndustriesArr = []
        }
        if (this.industries.length >= 3) {
          this.$message.warning('最多选择三个');
          return false;
        }
        this.industries.push(data.id);
        this.industry_names.push(data.name);
        this.selectIndustriesArr.push(data);
      } else {
        this.industries.splice(this.industries.indexOf(data.id), 1);
        this.industry_names.splice(this.industry_names.indexOf(data.name), 1);
        this.selectIndustriesArr.splice(this.selectIndustriesArr.indexOf(data), 1);
        if (!this.industry_names.length){
          this.industries = [];
          this.industry_names = ['不限']
          this.selectIndustriesArr = [{ name: '不限', id: 0, check: '' }]
        }
      }
    },
    async save() {
      // if (!this.is_student && !this.isActiveSave) {
      //   this.$message.error(this.isActive());
      //   return false;
      // }

      let industry_ids = this.industries;
      let city_ids = this.cities;
      if(city_ids.indexOf(0) !== -1){
        city_ids = []
      }
      if(industry_ids.indexOf(0) !== -1){
        industry_ids = []
      }
      let work_times = []
      if (this.work_time != "不限"){
        work_times.push(this.work_time)
      }

      // 空数组说明选择的全国，全国id是0，这样其他端才能获取到值
      if (city_ids.length === 0) city_ids = [0]

      let data = {
        industry_ids: industry_ids,
        profession_full_ids: this.professionsConfirmData.map(item => item.profession_id).flat(Infinity),
        // work_time: work_times,
        city_ids: city_ids,
        expect_min_salary: this.expect_min_salary,
        expect_max_salary: this.expect_max_salary
      };
      let queryData = await dealSignatrue(data);
      let res = await api.identity.updateInten(queryData);
      if (res.code === 1000) {
        this.$message.success('保存成功');
        this.$emit('update', {reload: true, identify: this.userIdentify});
        this.$emit('clone');
      }
    },
    //选择职业事件
    handleCheckProfessions({level1Index, level2Index, level3Index, listItem, type,}) {
      if(type==='level1'){
        //查找当前是否已经选中
        let checkIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === listItem.profession_id);
        //查找当前大分类中是否有已经选中的
        let hasCurrentLevel = this.professionsConfirmData.findIndex(item=> item.level1Index === level1Index);
        if(checkIndex>-1){
          //反选
          this.professionsConfirmData.splice(checkIndex,1);
          this.professionsTree[level1Index].checked = false;
        }else if(this.professionsConfirmData.length === 3 && hasCurrentLevel===-1){
          this.$message.warning("最多选择三个")
          return
        }else{
          this.professionsTree[level1Index].checked = true;
          // 向下清除选中状态(2/3级)
          this.professionsTree[level1Index].list.forEach((sitem,sindex)=>{
            let levelIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === sitem.profession_id);
            if(levelIndex>-1){
              this.professionsConfirmData.splice(levelIndex,1);
            }
            sitem.checked = false;
            sitem.list.forEach(ssitem=>{
              let levelIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === ssitem.profession_id);
              if(levelIndex>-1){
                this.professionsConfirmData.splice(levelIndex,1);
              }
              ssitem.checked = false;
            })
          })
          //添加
          this.professionsConfirmData.push({
            title: listItem.title,
            profession_id: listItem.profession_id,
            listItem,
            type,
            level1Index
          })
        }
      }else if(type === 'level2'){
        // 查找当前一级分类是否选中
        // if(this.professionsTree[level1Index].checked){
        //   return
        // }
        //查找当前是否已经选中
        let checkIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === listItem.profession_id);
        //查找当前大分类/小模块中是否有已经选中的
        let hasCurrentLevel = this.professionsConfirmData.findIndex(item=> item.level1Index === level1Index && item.level2Index === level2Index);

        if(checkIndex>-1){
          //反选
          this.professionsConfirmData.splice(checkIndex,1);
          this.professionsTree[level1Index].list[level2Index].checked = false;
        }else if(this.professionsConfirmData.length === 3 && hasCurrentLevel === -1){
          this.$message.warning("最多选择三个")
          return
        }else{
          this.professionsTree[level1Index].list[level2Index].checked = true;
          // 向下清除选中状态（3级）
          this.professionsTree[level1Index].list[level2Index].list.forEach((sitem,sindex)=>{
            let levelIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === sitem.profession_id);
            sitem.checked = false;
            if(levelIndex>-1){
              this.professionsConfirmData.splice(levelIndex,1);
            }
          })
          // 向上清除选中状态 (1级)
          let topItem = this.professionsTree[level1Index]
          let levelIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === topItem.profession_id);
          topItem.checked = false;
          if(levelIndex>-1){
            this.professionsConfirmData.splice(levelIndex,1);
          }
          //添加
          this.professionsConfirmData.push({
            title: listItem.title,
            profession_id: listItem.profession_id,
            listItem,
            type,
            level1Index,
            level2Index,
          })
        }
      }else if(type === 'level3') {
        // if(this.professionsTree[level1Index].checked || this.professionsTree[level1Index].list[level2Index].checked){
        //   return
        // }

        // 向上清除选中状态 (1级)
        let topItem = this.professionsTree[level1Index]
        let levelIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === topItem.profession_id);
        topItem.checked = false;
        if(levelIndex>-1){
          this.professionsConfirmData.splice(levelIndex,1);
        }
        // 向上清除选中状态 (2级)
        let level2Item = this.professionsTree[level1Index].list[level2Index]
        let targetLevel2Index = this.professionsConfirmData.findIndex(item=> item.profession_id === level2Item.profession_id);
        if(targetLevel2Index>-1){
          this.professionsConfirmData.splice(targetLevel2Index,1);
        }
        level2Item.checked = false;

        //查找当前是否已经选中
        let checkIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === listItem.profession_id);
       
        if(checkIndex>-1){
          //反选
          this.professionsConfirmData.splice(checkIndex,1);
          this.professionsTree[level1Index].list[level2Index].list[level3Index].checked = false;
        }else if(this.professionsConfirmData.length === 3){
          this.$message.warning("最多选择三个")
          return
        }else{

          this.professionsTree[level1Index].list[level2Index].list[level3Index].checked = true;

          //添加
          this.professionsConfirmData.push({
            title: listItem.title,
            profession_id: listItem.profession_id,
            listItem,
            type,
            level1Index,
            level2Index,
            level3Index,
          })
        }
      }
    },
    //获取树形结构的职位类型
    getProfessionsTree(profession_ids=[]){
      let professionsConfirmData = [];
      api.staticApi.getProfessionsTree().then(res=>{
        if(res.code === 1000){
          console.log("res=>", res)

          res.data.forEach((item,index)=>{
            item.title = `全部${item.title}`
            //检测是否选中
            if(profession_ids.includes(item.profession_id)){
              professionsConfirmData.push({
                title: item.title,
                profession_id: item.profession_id,
                listItem: item,
                type: 'level1',
                level1Index: index,
                level2Index: '',
                level3Index: '',
              })
              item.checked = true;
            }else{
              item.checked = false;
            }
            // 去除 其他开头的职位
            item.list = item.list.filter((filterItem, filterIndex) => !filterItem.title.startsWith('其他'))
            
            // level2
            item.list.forEach((sitem,sindex)=>{
              sitem.title = `全部${sitem.title}`
              //检测是否选中
              if(profession_ids.includes(sitem.profession_id)){
                professionsConfirmData.push({
                  title: sitem.title,
                  profession_id: sitem.profession_id,
                  listItem: sitem,
                  type: 'level2',
                  level1Index: index,
                  level2Index: sindex,
                  level3Index: '',
                })
                sitem.checked = true;
              }else{
                sitem.checked = false;
              }
              
              // level3
              sitem.list.forEach((ssitem, ssindex)=>{
                //检测是否选中
                if(profession_ids.includes(ssitem.profession_id)){
                  professionsConfirmData.push({
                    title: ssitem.title,
                    profession_id: ssitem.profession_id,
                    listItem: ssitem,
                    type: 'level3',
                    level1Index: index,
                    level2Index: sindex,
                    level3Index: ssindex,
                  })
                  ssitem.checked = true;
                }else{
                  ssitem.checked = false;
                }
              })

            })

          })
          this.professionsTree = res.data
          this.professionsConfirmData = professionsConfirmData;
        }
      })
    },
    // selectProfessions(data) {
    //   if (!data) return false
    //   // 选项为不限
    //   if (data.name === '不限') {
    //     this.professions = [];
    //     this.professionNames = ['不限'];
    //     this.selectProfessionsArr = [{ name: '不限', check: true }]
    //     return false;
    //   }
    //   // 点击了除不限之外的选项
    //   if (this.professionNames && this.professionNames.indexOf(data.name) === -1) {
    //     // 选项中存有不限则清空状态
    //     if (this.professionNames.indexOf('不限') !== -1){
    //       this.professions = [];
    //       this.professionNames = [];
    //       this.selectProfessionsArr = []
    //     }
    //     if (this.professionNames.length >= 3) {
    //       this.$message.warning('最多选择三个');
    //       return false;
    //     }
    //     data.results.forEach((item,index)=>{
    //       this.professions.push(item);
    //     })
    //     this.professionNames.push(data.name);
    //     this.selectProfessionsArr.push(data);
    //   } else {
    //     if (!this.professions) return false
    //     data.results.forEach((item,index)=>{
    //       this.professions.splice(this.professions.indexOf(item), 1);
    //     })
    //     this.professionNames.splice(this.professionNames.indexOf(data.name), 1);
    //     this.selectProfessionsArr.splice(this.selectProfessionsArr.indexOf(data), 1);
    //     if (!this.professions.length){
    //       this.professions = [];
    //       this.professionNames = ['不限'];
    //       this.selectProfessionsArr = [{ name: '不限', check: true }]
    //     }
    //   }
    // },
    // getSelectedProfessions(){
    //   if (!this.professions.length) {
    //     this.professions = [];
    //     this.professionNames = ["不限"];
    //     this.selectProfessionsArr = [{ name: '不限', check: true }]
    //   }else{
    //     this.selectProfessionsArr = []
    //     this.professionNames = this.userIntention.professions
    //     this.professions.forEach(Sid => {
    //       this.allProfessionsArr.forEach(item => {
    //         if (item.results && item.results.includes(Sid)){
    //           item.check = 'active';
    //         }
    //       });
    //     });
    //     this.allProfessionsArr.forEach(item => {
    //       if(item.check == 'active'){
    //         this.selectProfessionsArr.push(item)
    //       }
    //     })
    //   }
    // },
    // async getAllProfessions() {
    //   await api.recruit.get_professions_hot_name().then(res => {
    //     if (res.code === 1000) {
    //       let professionsArr = [ { name: '不限', check: '' } ];
    //       res.data.forEach(item => {
    //         item.check = '';
    //       });
    //       res.data.forEach(item => {
    //         professionsArr.push(item);
    //       });
    //       this.allProfessionsArr = professionsArr
    //       this.getSelectedProfessions()
    //     }
    //   });
    // },
  }
}
</script>
<style lang="scss" scoped>
  @import './intention.scss';

  .tips{
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    background: #F9F9F9;
    color: #9C9C9C;
    font-size: 14px;
    height:40px;
    padding: 10px 16px;
    box-sizing: border-box;
    border-radius: 4px;
    margin-top: 15px;
    span{
      color: #FF6644;
      cursor: pointer;
      &:hover{
        opacity: 0.8;
      }
    }
  }
</style>
<style lang="scss">
  .intention-box-main.cvs-intention {
    .salary {
      .el-input {
        width: 100%;
        border: none;
        .el-input__inner {
          border: none!important;
          .el-input__suffix {
            display: none!important;
          }
        }
        .el-input__suffix {
          display: none!important;
        }
      }
    }
  }

  .dark-theme-select-intention-select{
    background: #303336;
    border-color: #303336;
    .popper__arrow{
      border-bottom-color: #25272D !important;
      &::after {
        border-bottom-color: #303336 !important;
      }
    }
    .el-select-dropdown__item{
      color: #fff;
      height: 44px;
      line-height: 44px;
      &.hover,&.selected{
        background: #303336;
        color: #FF6644;
      }
    }
    .el-select-dropdown__empty{
      line-height: 24px;
    }
  }
</style>
